import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createSlots as _createSlots, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-center w-full"
};
const _hoisted_2 = {
  key: 2,
  class: "mt-4"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "flex-center w-full mt-4"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
import { Season } from "@/modules/season/entity";
import { Team } from "@/modules/team/entity";
import RichDialogRow from "@/modules/vue/components/RichDialogRow.vue";
import Gate from "@/modules/action-points/components/Gate.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'RichDialog',
  props: {
    days: null,
    hideDurationDate: {
      type: Boolean
    },
    price: null,
    confirmationDisabled: {
      type: Boolean
    },
    confirmationText: null,
    confirmationOnly: null,
    cancelText: null,
    showOkOnly: {
      type: Boolean
    },
    showConfirmationInput: {
      type: Boolean
    },
    hideActions: {
      type: Boolean
    },
    doNotCheckBalance: {
      type: Boolean
    },
    gateType: null,
    gateValue: null,
    gateMeta: null
  },
  emits: ['cancelled', 'confirmed'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const season = ref();
    const team = ref();
    const showState = ref(false);
    const show = async () => {
      season.value = await Season.current();
      team.value = await Team.current();
      showState.value = true;
    };
    const hide = () => showState.value = false;
    const confirmation = ref(false);
    const confirmButtonDisabled = computed(() => {
      return props.confirmationDisabled || !!props.price && !props.doNotCheckBalance && (!team.value || props.price > team.value.balance) || props.showConfirmationInput && !confirmation.value;
    });
    const durationDate = computed(() => {
      if (!props.days || props.hideDurationDate) {
        return null;
      }
      return season.value.currentDate.add(props.days, 'days');
    });
    const resolve = ref();
    const reject = ref();
    const onCancel = () => {
      reject.value();
      emit('cancelled');
    };
    const confirm = () => {
      if (reject.value) {
        reject.value();
      }
      show();
      return new Promise((res, rej) => {
        reject.value = () => {
          showState.value = false;
          rej();
          emit('cancelled');
        };
        resolve.value = commit => {
          reject.value = null;
          showState.value = false;
          res(commit);
          emit('confirmed');
        };
      });
    };
    expose({
      show,
      hide,
      confirm
    });
    return (_ctx, _cache) => {
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NModal = _resolveComponent("NModal");
      return _openBlock(), _createBlock(_Teleport, {
        to: "#app-outside"
      }, [_createVNode(_component_NModal, {
        show: showState.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => showState.value = $event),
        preset: "dialog",
        "show-icon": false,
        closable: false,
        "auto-focus": "",
        "trap-focus": "",
        "mask-closable": false,
        "close-on-esc": false
      }, _createSlots({
        header: _withCtx(() => [_ctx.$slots.title ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "title")])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", null, [_ctx.$slots.default || !!__props.confirmationOnly ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["py-2", {
            'mb-4': !__props.hideActions,
            'text-xl text-center': !!__props.confirmationOnly
          }])
        }, [!!__props.confirmationOnly ? _renderSlot(_ctx.$slots, "default", {
          key: 0
        }, () => [_createTextVNode(_toDisplayString(__props.confirmationOnly), 1)]) : _renderSlot(_ctx.$slots, "default", {
          key: 1
        }), __props.showConfirmationInput ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_NCheckbox, {
          checked: confirmation.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = $event => confirmation.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('confirm_your_decision')), 1)]),
          _: 1
        }, 8, ["checked"])])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "rows"), __props.days !== undefined ? (_openBlock(), _createBlock(RichDialogRow, {
          key: 0,
          class: "last:mb-4"
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('duration')), 1)]),
          value: _withCtx(() => [__props.days === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_3], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", null, _toDisplayString(_ctx.$duration(__props.days, 'days').humanize()), 1), _unref(durationDate) ? (_openBlock(), _createElementBlock("div", _hoisted_4, "(" + _toDisplayString(_ctx.$date(_unref(durationDate))) + ")", 1)) : _createCommentVNode("", true)], 64))]),
          _: 1
        })) : _createCommentVNode("", true), __props.price !== undefined ? (_openBlock(), _createBlock(RichDialogRow, {
          key: 1,
          class: "last:mb-4",
          color: __props.doNotCheckBalance || __props.price <= team.value.balance ? _ctx.ColorEnum.Green : _ctx.ColorEnum.Red
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('price')), 1)]),
          value: _withCtx(() => [_createTextVNode(_toDisplayString(__props.price === 0 ? '--' : _ctx.$money(__props.price)), 1)]),
          _: 1
        }, 8, ["color"])) : _createCommentVNode("", true)])])]),
        _: 2
      }, [!__props.hideActions ? {
        name: "action",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "action", {}, () => [_createElementVNode("div", _hoisted_5, [__props.showOkOnly ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          secondary: "",
          onClick: hide
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ok')), 1)]),
          _: 1
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_NButton, {
          secondary: "",
          onClick: onCancel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.cancelText ?? _ctx.$t('cancel')), 1)]),
          _: 1
        }), _hoisted_6, __props.gateType ? (_openBlock(), _createBlock(Gate, {
          key: 0,
          type: __props.gateType,
          value: __props.gateValue,
          meta: __props.gateMeta,
          disabled: _unref(confirmButtonDisabled),
          onAction: _cache[1] || (_cache[1] = commit => resolve.value({
            commit
          }))
        }, null, 8, ["type", "value", "meta", "disabled"])) : (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          type: "success",
          secondary: "",
          disabled: _unref(confirmButtonDisabled),
          onClick: _cache[2] || (_cache[2] = () => resolve.value())
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmationText ?? _ctx.$t('confirm')), 1)]),
          _: 1
        }, 8, ["disabled"]))], 64))])])])
      } : undefined]), 1032, ["show"])]);
    };
  }
});